import { render } from "./ClinicCard.vue?vue&type=template&id=bb1b5a3c&ts=true"
import script from "./ClinicCard.vue?vue&type=script&lang=ts"
export * from "./ClinicCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__